export const LEGAL_NOTICE_CONTENT = `
## 1. Datos identificativos

En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE), se informa de los siguientes datos:

| Concepto | Dato |
| --- | --- |
| Titular | Alejandro Serrano Notivoli |
| NIF | ES29133706C |
| Domicilio | C/ Felipe Sanclemente 8, 4B, 50001, Zaragoza, España |
| Correo electrónico | soporte@alejandrosn.com |
| Sitio web | https://blunticle.alejandrosn.com |

## 2. Objeto

El presente sitio web da acceso a **Blunticle**, una herramienta SaaS de generación de contenido asistida por inteligencia artificial. A través de la plataforma, los usuarios registrados pueden crear, gestionar y revisar contenidos generados de forma asíncrona.

## 3. Condiciones de uso

El acceso y uso de Blunticle implica la aceptación de las presentes condiciones, así como de la [Política de Privacidad](/politica-privacidad) y la [Política de Cookies](/politica-cookies).

El usuario se compromete a:

- Facilitar datos veraces en el registro y mantenerlos actualizados.
- No utilizar el servicio con fines ilícitos o contrarios al orden público.
- No intentar acceder sin autorización a sistemas, datos o cuentas de otros usuarios.
- Respetar los derechos de propiedad intelectual e industrial del titular y de terceros.

El titular se reserva el derecho de suspender o cancelar el acceso de usuarios que incumplan estas condiciones.

## 4. Propiedad intelectual e industrial

Todos los contenidos del sitio web —textos, diseño, código, logotipos, interfaces y software— son propiedad de Alejandro Serrano Notivoli o de sus licenciantes, y están protegidos por la legislación española e internacional en materia de propiedad intelectual e industrial.

Queda prohibida su reproducción, distribución o transformación sin autorización expresa del titular, salvo en los casos permitidos por la ley.

Los contenidos generados por los usuarios mediante la plataforma pertenecen a dichos usuarios, conforme a las condiciones del servicio.

## 5. Responsabilidad

El titular no se hace responsable de:

- Interrupciones del servicio por mantenimiento, causas técnicas o fuerza mayor.
- Contenidos generados por la IA que el usuario decida publicar sin revisión previa.
- Enlaces a sitios de terceros que puedan aparecer en contenidos generados.
- Uso indebido del servicio por parte de los usuarios.

Blunticle utiliza modelos de inteligencia artificial que pueden producir resultados inexactos o incompletos. El usuario es responsable de revisar y validar el contenido antes de su publicación.

## 6. Legislación aplicable y jurisdicción

Las presentes condiciones se rigen por la legislación española. Para la resolución de cualquier controversia, las partes se someten a los Juzgados y Tribunales de Zaragoza, salvo que la normativa de consumo aplicable disponga otro fuero imperativo.
`;
